var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"d-flex align-center"},[_c('v-img',{attrs:{"contain":"","width":"50","height":"50","src":_vm.pictureUrl}})],1),_c('div',[_c('p',{staticClass:"text-center black--text"},[_vm._v(" "+_vm._s(_vm.name)+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }